export interface IListSeasons {
  __typename: 'SeasonType';
  id: string;
  name: string;
  startDate: string;
  endDate: string;
  status: keyof typeof SEASONS_STATUS;
}

export enum SEASONS_STATUS {
  ACTIVE = 'ACTIVE',
  COMPLETE = 'COMPLETE'
}
